import { useSessionStorage } from "vue-composable";
import { watch } from "vue";
import Analytics from "src/composables/Analytics";
const { log_event } = Analytics();

const sort_options = [
  { type: 'price', desc: true, label: 'Price (low to high)' },
  { type: 'price', desc: false, label: 'Price (high to low)' },
  { type: 'term', desc: true, label: 'Term / Contract Length (shorter to longer)' },
  { type: 'term', desc: false, label: 'Term / Contract Length (longer to shorter)' }
]
const { storage: sort_option } = useSessionStorage('sort_option', sort_options[0]);

watch(sort_option, () => {
  log_event({ name: 'shop_select_sort', sort_option: sort_option.value });
})

const clear = () => {
  sort_option.value = sort_options[0];
}

export default () => {
  return {
    sort_option,
    sort_options,
    clear
  }
}
